import styled from 'styled-components'
import Popper from '../Popper'

export const Arrow = styled.div`
  position: absolute;
  width: 8px;
  height: 8px;
  zindex: 999;
`

export const ArrowSvg = styled.svg`
  display: inline;
  margin-top: -24px;
  margin-left: -4px;
  z-index: 999;

  @media ${ (props) => props.theme.breakpoints.devices.max.lg } {
    margin-top: -22px;
  }
`

export const Tooltip = styled.div`
  max-width: 270px;

  &.long-text {
    max-width: 400px;
  }
`

export const TooltipInner = styled.div`
  padding: 15px;
  background-color: #fff;
  border: 1px solid ${ (props) => props.theme.colors['aok-gruen'] };
  font-size: 16px;
  font-weight: 200;
  line-height: 1.56;
  white-space: normal;
`

export const PopperComponent = styled(Popper)`
  z-index: 999;
  &[data-popper-placement='bottom'] ${ Arrow } {
    top: -4px;
  }

  &[data-popper-placement='bottom-start'] ${ Arrow } {
    top: -4px;
  }

  &[data-popper-placement='bottom-end'] ${ Arrow } {
    top: -4px;
  }

  &[data-popper-placement^='top'] ${ Arrow } {
    bottom: -4px;
  }

  &[data-popper-placement='right'] ${ Arrow } {
    left: -4px;
  }

  &[data-popper-placement^='left'] ${ Arrow } {
    right: -4px;
  }
`
